var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-spacer'),_c('v-toolbar-title',[_vm._v("Клиенты")]),_c('v-spacer')],1),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }